import { createContext, ReactNode, useContext } from 'react'

export interface TableV2ContextValue {
	/** When true, tables use new V2 styling and features (column order/visibility, toolbar search/filter/export, etc.). Only enabled for ViewDetailV2. */
	v2Ready: boolean
}

const defaultValue: TableV2ContextValue = {
	v2Ready: false,
}

export const TableV2Context = createContext<TableV2ContextValue>(defaultValue)
TableV2Context.displayName = 'TableV2Context'

export const useTableV2Ready = (): boolean => {
	const ctx = useContext(TableV2Context)
	return ctx?.v2Ready ?? false
}

export const TableV2Provider = ({
	children,
	value,
}: {
	children: ReactNode
	value: TableV2ContextValue
}) => (
	<TableV2Context.Provider value={value}>{children}</TableV2Context.Provider>
)
